import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import PageHeader from "../../components/page-header";
import Loader from "../../shared/loader";
import Swal from "sweetalert2";
import axios from "axios";
import Select from "react-select";

const selectStyles = {
  menu: (baseStyles, state) => ({
    ...baseStyles,
    marginTop: 2,
    zIndex: 999,
  }),
};

const ProductList = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [listData, setListData] = useState([]);
  const [userDrp, setUserDrp] = useState([]);
  const [user, setUser] = useState(null);
  const [seriesDrp, setSeriesDrp] = useState([]);
  const [series, setSeries] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [isAllowed, setIsAllowed] = useState(false);

  const fetchUserData = () => {
    setLoading(true);
    axios.post(API_URL.USER_LIST, {}).then((res) => {
      setUserDrp(
        res.data.data.data.map((user) => {
          return {
            label: user.name,
            value: user.id,
          };
        })
      );
      setLoading(false);
    });
  };

  const fetchSeriesData = () => {
    if (!user) {
      return false;
    }
    setLoading(true);
    axios.post(API_URL.SERIES_LIST, { user_id: user }).then((res) => {
      setSeriesDrp(
        res.data.data.map((series) => {
          return {
            label: series.name,
            value: series.id,
          };
        })
      );
      setLoading(false);
    });
  };

  const fetchListData = () => {
    if (!user) {
      return false;
    }
    setLoading(true);
    axios.post(API_URL.PRODUCT_LIST, {
        user_id: user,
        series_id: series,
        name: searchValue,
      })
      .then((response) => {
        setListData(
          response.data.data.data.map((product) => {
            return { ...product, isSelect: false };
          })
        );
        setLoading(false);
        if (sessionStorage.getItem('pId')) {
          let rId = 'row-' + JSON.parse(sessionStorage.getItem('pId'));
          setTimeout(() => {
            scrollToRow(rId);
          }, 100)
        }
      });
  };

 const editProduct = (id) => {
  if (user) {
    sessionStorage.setItem('pUser', JSON.stringify(user));
    if (series) {
      sessionStorage.setItem('pSeries', JSON.stringify(series));
    }
  }
  sessionStorage.setItem('pId', JSON.stringify(id));
  navigate("/admin/product/edit/" + id);
  }

  const deleteProduct = (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this - " + row.name,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios.post(API_URL.PRODUCT_DELETE, { id: row.id }).then(
          (res) => {
            if (res.data.status === 1) {
              let newData = listData.filter((r) => r.id != row.id);
              setListData(newData);
            }
            toast.success(row.name + " Delete Successfully", {
              autoClose: 3000,
              position: "top-center",
            });
            setLoading(false);
          },
          () => {
            setLoading(false);
            toast.error("Something went wrong..", {
              autoClose: 3000,
              position: "top-center",
            });
          }
        );
      }
    });
  };

  const userInfo = () => {
    axios.post(API_URL.LOGIN_USER, {}).then((res) => {
      if (res.data) {
        setIsAllowed(res.data.is_allowed);
        if (!res.data.is_allowed) {
          setUser(res.data.id);
        } else {
          fetchUserData();
        }
      }
    });
  }

  useEffect(() => {
    user && fetchListData();
  }, [user, series]);

  useEffect(() => {
    fetchSeriesData();
    userInfo();

    if (sessionStorage.getItem('pUser')) {
      setUser(JSON.parse(sessionStorage.getItem('pUser')))
    }
    if (sessionStorage.getItem('pSeries')) {
      setSeries(JSON.parse(sessionStorage.getItem('pSeries')))
    }
  }, []);

  useEffect(() => {
    if (user) {
      fetchSeriesData(user);
    } else {
      setSeriesDrp([]);
    }
  }, [user]);

  const scrollToRow = (rowId) => {
    const rowElement = document.getElementById(rowId);
    if (rowElement) {
      rowElement.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  return (
    <>
      <PageHeader
        pageTitle={"Product"}
        count={listData.length}
        addPageUrl={"/admin/product/add"}
      />
      <div>
        <div className="d-flex">
          {isAllowed && <div className="form-group me-3" style={{ width: "300px" }}>
            <Select
              options={userDrp}
              placeholder="Select User..."
              value={userDrp.find((d) => d.value === user)}
              styles={selectStyles}
              onChange={(e) => {
                setUser(e.value);
              }}
            />
          </div>}
          <div className="form-group me-3" style={{ width: "300px" }}>
            <Select
              options={seriesDrp}
              placeholder="Select Series..."
              value={seriesDrp.find((d) => d.value === series)}
              styles={selectStyles}
              onChange={(e) => {
                setSeries(e.value);
              }}
            />
          </div>
          <div className="form-group" style={{ width: "300px" }}>
            <input
              type="text"
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchListData();
                }
              }}
              className="form-control"
              placeholder="Search"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <div className="card-table">
              <div className="card-body">
                {loading && <Loader></Loader>}
                {!loading && (
                    <table className="table table-center table-hover datatable">
                      <thead className="thead-light">
                        <tr>
                          <th>#</th>
                          <th>Photo</th>
                          <th>Name</th>
                          <th>Series</th>
                          <th>Size</th>
                          <th className="text-center">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {listData.map((row, key) => {
                          return (
                            <tr id={"row-" + row.id} key={key}>
                              <td className="td-hash">{key + 1}</td>
                              <td className="td-avatar">
                                <div
                                  style={{
                                    backgroundImage: "url(" + row.image + ")",
                                  }}
                                ></div>
                              </td>
                              <td>{row.name}</td>
                              <td>{row?.series?.name}</td>
                              <td>{row.size}</td>
                              <td className="td-action">
                                <div>
                                <button
                                    onClick={() => editProduct(row.id)}
                                    className="btn btn-sm btn-secondary"
                                  >
                                    <i className="fa fa-edit"></i>
                                  </button>
                                  <button
                                    onClick={() => deleteProduct(row)}
                                    className="btn btn-sm btn-danger"
                                  >
                                    <i className="fa fa-trash"></i>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ProductList;
